import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { auth, db } from "../../../firebase";
import { collection, query, where, getDocs, getDoc, doc } from "firebase/firestore";

import Loading from "../../Loading";

import styleClasses from '../css/mobile/MyPage.module.scss';

function MusicardSelectorPopup({ open, setOpenPopup, setSelectedSource }) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm]   = useState("");
  const [active, setActive]           = useState('');
  const [musicards, setMusicards]     = useState([]);
  const [isLoading, setIsLoading]     = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const uid = auth.currentUser ? auth.currentUser.uid : null;

  // 🔹 팝업 열기/닫기
  useEffect(() => {
    setActive(open ? styleClasses.active : '');
  }, [open, setOpenPopup, active])

  // 검색 버튼을 누르면 실행
  const handleSearch = async () => {
    if (!uid) {
      navigate("/login");
      return;
    }
    setIsLoading(true);
    try {
      // 활성화된 뮤지카드만 쿼리 (act가 true)
      const q = query(
        collection(db, "musicians"),
        where("act", "==", true)
      );
      const snapshot = await getDocs(q);
      // 전체 결과에서 searchTerm에 해당하는 이름을 필터링 (대소문자 무시)
      const results = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((card) =>
          card.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      setMusicards(results);
    } catch (error) {
      console.error("뮤지카드 검색 오류:", error);
    }
    setHasSearched(true);
    setIsLoading(false);
  };

  // 항목 선택 시 처리
  const handleSelect = async (card) => {
    try {
      // /musicians/[뮤지카드ID]/style/main 문서에서 sns 필드 가져오기
      const styleRef = doc(db, "musicians", card.id, "style", "main");
      const styleSnap = await getDoc(styleRef);
      const sns = styleSnap.exists() ? styleSnap.data().sns || {} : {};
      // /musicians/[뮤지카드ID] 문서에서 name과 positions 정보 가져오기
      const musicianRef = doc(db, "musicians", card.id);
      const musicianSnap = await getDoc(musicianRef);
      const name = musicianSnap.exists() ? musicianSnap.data().name || "" : "";
      const positions = musicianSnap.exists() ? musicianSnap.data().positions || {} : {};

      const result = {
        link: `https://musizic.com/musicard/${card.id}`,
        profileImage: card.profileImage || "",
        sns: sns,
        name: name,
        positions: positions
      };

      setSelectedSource(result);
      setOpenPopup(false);
    } catch (error) {
      console.error("뮤지카드 선택 오류:", error);
      alert("뮤지카드 정보를 가져오는 중 오류가 발생했습니다.");
    }
  };

  const enterKeyword = (event) => {
    if (event.key === 'Enter') {
      handleSearch(event);
    }
  }

  return (
    <>
      <div className={`${ styleClasses.backDropMobile } ${ active }`} onClick={ () => { setActive(''); setOpenPopup(false); } }/>
      <div className={`${ styleClasses.musicardSelectorPopupMobile } ${ active }`}>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.header }>
            <div className={ styleClasses.title }>
              <h1>뮤지카드 검색</h1>
            </div>
            <div className={ styleClasses.closeButton }>
              <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                <div className="commonIcon">
                  <i className="closeWhite w32"></i>
                </div>
              </button>
            </div>
            <div className={`commonForm ${ styleClasses.searchRow }`}>
              <div className="formRow">
                <div className={`fieldBox ${ styleClasses.inputWithButton }`}>
                  <input type="text" placeholder="뮤지카드 이름 검색..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyDown={ enterKeyword } />
                  <div className="commonButton fullWidth">
                    <button onClick={ handleSearch }>검색</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${ styleClasses.content } ${ isLoading ? styleClasses.noScroll : undefined }`}>
            {isLoading && <Loading />}
            {hasSearched && (
              <div className={ styleClasses.musicardList }>
                {musicards.length > 0 ? (
                  musicards.map((card) => (
                    <div key={card.id} className={ styleClasses.eachCard } onClick={() => handleSelect(card)}>
                      {card.profileImage ? (
                        <img className={ styleClasses.profileImage } src={card.profileImage} alt={card.name} />
                      ) : (
                        <div className={ styleClasses.profileImage }>이미지 없음</div>
                      )}
                      <p>{card.name || "이름 없음"}</p>
                    </div>
                  ))
                ) : (
                  <p className={ styleClasses.noResult }>검색 결과가 없습니다.</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MusicardSelectorPopup;